import DashboardLayout from 'components/DashboardLayout';
import NotificationsBloc from 'components/NotificationsBloc';
import ActionButtons from 'containers/ASIDashboard/actionButtons';
import MyContracts from 'containers/ASIDashboard/MyContracts';
import Services from 'containers/ASIDashboard/services';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import WelcomeHeader from 'containers/AUTODashboard/Header/WelcomeHeader';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import HeaderASI from 'images/header-asi.png';
import { get } from 'lodash';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PAGES from 'routes/pages';
import { getContratsASI } from 'store/contract/actions';
import { getContractASISelector } from 'store/contract/selectors';
import {
  getFaq,
  getLastNotification,
  setASIDetailsPageBreadcrumbsPath,
  setNotificationRead,
} from 'store/global/actions';
import {
  getASIFaqSelector,
  getLastNotificationASISelector,
} from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getFirstNameSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';

const CONTRACTS = (contract: {}) => [
  {
    status: 'Actifs',
    id: get(contract, ['contractASI', 'id'], ''),
    deadline: '',
    product: get(contract, ['contractASI', 'TypeAssure'], ''),
    policyNumber: get(contract, ['contractASI', 'Police'], ''),
  },
];
const LAST_NOTIFICATION = {
  type: 'santé',
  id: 1,
  idApp: 'fake',
  action_title: 'fake',
  message: 'fake-message',
  title: 'fake-title',
  policyNumber: 'fake-policy-number',
  status: 'fake-status',
  read: 0,
};

const ASIDashboard = ({
  getLastNotification,
  lastNotification,
  setNotificationRead,
  ...props
}: {
  intl: IntlShape;
  firstName: string;
  setASIDetailsPageBreadcrumbsPath: Function;
  getLastNotification: Function;
  setNotificationRead: Function;
  lastNotification: {
    type: string;
    id: Number;
    idApp: string;
    action_title: string;
    message: string;
    title: string;
    policyNumber: string;
    status: string;
    read: boolean;
  };
  getFaq: Function;
  faq: { question: string; code: string; id: number }[];
  contractsASI: {};
  getContratsASI: Function;
}) => {
  const language = useSelector(getLocaleSelector);
  const { ASI } = PRIVILEGES;

  useEffect(() => {
    getLastNotification(ASI);
  }, [ASI, getLastNotification]);
  /* eslint-disable */
  useEffect(() => {
    props.getFaq(language);
    props.getContratsASI({ language });
    // eslint-disable-next-line
  }, [language]);

  return (
    <>
      <DashboardLayout
        MyContracts={
          <MyContracts
            contracts={CONTRACTS(props.contractsASI)}
            setDetailsPageBreadcrumbsPath={
              props.setASIDetailsPageBreadcrumbsPath
            }
          />
        }
        Faq={
          <Faq
            items={
              props.faq &&
              props.faq.map(
                (
                  item: { question: string; code: string; id: number },
                  index: number,
                ) => ({
                  title: (
                    <StyledShortBody
                      weight="bold"
                      color={sanlamDarkBlue}
                      key={index}
                    >
                      {item.question}
                    </StyledShortBody>
                  ),
                  path: PAGES.FAQ,
                  id: item.id,
                  code: item.code,
                  isFaq: true,
                  category: EVENT_CATEGORIES.ASI_ACCUEIL,
                  label: 'FAQ_' + ++index,
                }),
              )
            }
            GACategoryAllResponses={EVENT_CATEGORIES.ASI_ACCUEIL}
          />
        }
        WelcomeHeader={<WelcomeHeader name={props.firstName} />}
        HeaderImage={HeaderASI}
        ServicesBloc={<Services mdGrid={6} smGrid={6} />}
        NotificationsBloc={
          <NotificationsBloc
            message={
              LAST_NOTIFICATION?.message && LAST_NOTIFICATION.message
            }
            ignoreNotify={() =>
              setNotificationRead({
                id: LAST_NOTIFICATION.id,
                section: ASI,
                isRedirectTo: false,
              })
            }
            clickEvent={() =>
              setNotificationRead({
                id: LAST_NOTIFICATION.id,
                section: ASI,
              })
            }
          />
        }
        MenuItem={
          <ActionButtons
            setDetailsPageBreadcrumbsPath={
              props.setASIDetailsPageBreadcrumbsPath
            }
          />
        }
      />
    </>
  );
};

const mapDispatchToProps = {
  getLastNotification,
  setNotificationRead,
  getFaq,
  setASIDetailsPageBreadcrumbsPath,
  getContratsASI,
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    lastNotification: {
      type: string;
      id: Number;
      idApp: string;
      action_title: string;
      message: string;
      title: string;
      policyNumber: string;
      status: string;
      read: boolean;
    };
    firstName: string;
    faq: [];
    contractsASI: [];
  }
>({
  firstName: getFirstNameSelector,
  lastNotification: getLastNotificationASISelector,
  faq: getASIFaqSelector,
  contractsASI: getContractASISelector,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ASIDashboard));
export { ASIDashboard };
